//Luminous Lightbox JS
//https://github.com/imgix/luminous
import { LuminousGallery } from 'luminous-lightbox';
import { Luminous } from 'luminous-lightbox';

var galleryOpts = {
	// Whether pressing the arrow keys should move to the next/previous slide.
	arrowNavigation: true,
};

var luminousOpts = {
	// These options have the same defaults and potential values as the Luminous class.
};

new LuminousGallery(
	document.querySelectorAll(
		'.gallery a, .wp-block-gallery a, a.lightbox, .slider--product-specs a'
	)
);
